/* 效能面板。F3 開關，預設關閉。

   顯示的東西刻意跟「要做什麼最佳化」對應：
   · 幀時間看 p95 與 max 而不是平均 —— 掉幀是尖峰造成的，平均值會把它藏起來
   · 模擬與渲染分開 —— 前者要改演算法，後者要減 draw call，修的地方不同
   · draw call：0.2 的設計下實測約 100–300，不是瓶頸；但地形與特效變多時要盯著
   · 場上實體數用來判斷「是不是單純東西太多」還是「單位成本太高」 */

import { perf } from '../platform/perf';
import { resolutionInfo } from '../platform/resolution';

let el: HTMLElement | null = null;
let acc = 0;

const BUDGET_MS = 16.7;   // 60fps 的一幀預算

function bar(ms: number) {
  const n = Math.min(20, Math.round((ms / BUDGET_MS) * 20));
  return '█'.repeat(n) + '·'.repeat(20 - n);
}

function fmt(v: number, w = 5) {
  return v.toFixed(1).padStart(w);
}

export function initPerfOverlay() {
  el = document.createElement('div');
  el.id = 'perfPanel';
  el.style.cssText = [
    'position:fixed', 'left:16px', 'top:16px', 'z-index:9',
    'font:11px/1.5 ui-monospace,Menlo,Consolas,monospace',
    'color:#7dffa8', 'background:rgba(6,9,16,.82)',
    'border:1px solid rgba(125,255,168,.25)', 'padding:8px 10px',
    'white-space:pre', 'pointer-events:none', 'display:none',
    'backdrop-filter:blur(4px)',
  ].join(';');
  document.body.appendChild(el);

  window.addEventListener('keydown', function (e) {
    if (e.key === 'F3') {
      e.preventDefault();
      perf.detailed = !perf.detailed;
      if (el) el.style.display = perf.detailed ? 'block' : 'none';
    }
  });
}

/** 每幀呼叫。面板本身每 250ms 才重畫一次，避免量測工具自己變成瓶頸。 */
export function updatePerfOverlay(dtMs: number) {
  if (!perf.detailed || !el) return;
  acc += dtMs;
  if (acc < 250) return;
  acc = 0;

  const s = perf.snapshot();
  const c = s.counters;
  const r = resolutionInfo();
  const other = Math.max(0, s.frame.p50 - s.sim.p50 - s.render.p50);

  el.textContent = [
    `PERF  ${s.frame.fps.toFixed(0).padStart(3)} fps   樣本 ${s.samples}`,
    '',
    `幀   p50${fmt(s.frame.p50)}  p95${fmt(s.frame.p95)}  max${fmt(s.frame.max)} ms`,
    `     ${bar(s.frame.p50)} ${BUDGET_MS} ms 預算`,
    '',
    `模擬 ${fmt(s.sim.p50)} ms  max${fmt(s.sim.max)}   步/幀 ${s.steps.p50.toFixed(1)} (max ${s.steps.max})`,
    `渲染 ${fmt(s.render.p50)} ms  max${fmt(s.render.max)}`,
    `其他 ${fmt(other)} ms`,
    '',
    `draw call ${String(c.drawCalls).padStart(5)}   三角形 ${(c.triangles / 1000).toFixed(0)}k`,
    `幾何體    ${String(c.geometries).padStart(5)}   材質   ${c.textures}`,
    '',
    `敵人 ${String(c.enemies).padStart(4)}  子彈 ${String(c.bullets).padStart(4)}`,
    `殘骸 ${String(c.debris).padStart(4)}  拾取 ${String(c.orbs).padStart(4)}`,
    '',
    `像素比 ${r.ratio.toFixed(2)} / ${r.max.toFixed(2)}${r.auto ? ' (自動)' : ' (固定)'}`,
  ].join('\n');
}
